exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle[data-v-74e13d18]{background-color:grey;width:18px!important;height:18px!important;border-radius:50%!important;color:#fff;text-align:center;margin-left:10px}.titleSearch .v-input .v-text-field .v-input__slot[data-v-74e13d18]{border-radius:33px!important}", ""]);

// exports
